import {
  Stack,
  TextField,
} from '@mui/material';
import React, {type FC} from 'react';
import {Controller} from 'react-hook-form';

import {useMutateCreateUser} from '../../api/index.js';
import FormDialog from '../Forms/FormDialog.js';
import {type AddMonitorFormValues} from '../Forms/formTypes.js';
import {addMonitorFormSchema} from '../Forms/validations.js';
import PasswordField from '../PasswordField.js';

const defaultValues: AddMonitorFormValues = {
  name: '',
  email: '',
  password: '',
};

interface AddMonitorFormProps {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
}

const AddMonitorForm: FC<AddMonitorFormProps> = ({open, refetch, onClose}) => {
  const createMutation = useMutateCreateUser();
  return (
    <FormDialog
      open={open}
      name={'monitor'}
      onClose={onClose}
      data={defaultValues}
      schema={addMonitorFormSchema}
      onSubmit={async (data) => {
        await createMutation.mutateAsync({
          name: data.name,
          email: data.email,
          password: data.password,
        });
      }}
      refetch={refetch}
    >
      {(control, errors) => (
        <Stack spacing={2} sx={{mt: 2}}>
          <Controller
            name={'name'}
            control={control}
            render={({field}) => (
              <TextField
                {...field}
                InputLabelProps={{required: true}}
                error={!!errors?.name}
                helperText={errors?.name?.message}
                label={'Name'}
              />
            )}
          />
          <Controller
            name={'email'}
            control={control}
            render={({field}) => (
              <TextField
                {...field}
                InputLabelProps={{required: true}}
                error={!!errors?.email}
                helperText={errors?.email?.message}
                label={'Email'}
              />
            )}
          />
          <PasswordField
            name={'password'}
            control={control}
            errors={errors}
            required
          />
        </Stack>
      )}
    </FormDialog>
  );
};

export default AddMonitorForm;
